<app-shared-layout
        [Analysis]="title"
        [hideAdd]="true"
        animationSize="full"
        [secondaryWithStyle]="false"
        (closeDetails)="closePanel()">

    <div ngProjectAs="primary-panel">
        <div class="flex flex-col">
            <span class="text-xs text-gray">Building Name</span>
            <div class="flex items-center gap-3">
                <span class="px-2 py-1 text-xl bg-secondary text-white">{{data[0].name}}</span>
                <div class="grow  border-b border-gray-100">
                </div>
            </div>
        </div>

        <div class="grid grid-cols-3 gap-10">
            <div class="col-span-3 md:col-span-1 flex flex-col gap-5 justify-center">

                @for (card of cards; track card) {
                    <div class="move-left" style="--order: {{ $index+3 }}">
                        <app-summary-cards-variant
                                [card]="card">
                        </app-summary-cards-variant>
                    </div>
                }

            </div>
            <div class="col-span-3 md:col-span-2 flex flex-col gap-5 justify-center">
                <div class="flex justify-between items-center">
                    <div class="flex gap-2">
                        @for (tab of lineChartsTabs; track tab) {
                            <div
                                    [class.bg-primary-50]="activeSlugLineCharts === tab.slug"
                                    [class.text-primary-600]="activeSlugLineCharts === tab.slug"
                                    (click)="onTabChange(tab.slug)"
                                    class="py-2 px-3 rounded-xl cursor-pointer"
                            >
                                {{ tab.name }}
                            </div>
                        }
                    </div>

                    <div class="flex items-center gap-2 bg-primary-50 text-primary-600 py-2 px-3 rounded-xl">
                        <span>Since</span>
                        <input
                                type="datetime-local"
                                [(ngModel)]="sixHoursPast"
                                (change)="onTimeChange()"
                                class="py-1 px-2 border rounded text-sm bg-white text-primary-600">
                        <span>to</span>
                        <input
                                type="datetime-local"
                                [(ngModel)]="currentTime"
                                (change)="onTimeChange()"
                                class="py-1 px-2 border rounded text-sm bg-white text-primary-600">
                    </div>
                </div>
                @if (loadingData === true) {
                    <div class="skeleton-wrapper">
                        <ngx-skeleton-loader
                                count="1"
                                appearance="line"
                                [theme]="{ height: '350px', width: '100%' }">
                        </ngx-skeleton-loader>
                    </div>
                } @else {
                    @if (activeSlugLineCharts === 'lineChartsTemp') {
                        <div
                                class="col-span-3 md:col-span-2 w-full"
                                *ngIf="tempLineChartsData as serviceListSummary">
                            <app-bar-graph
                                           title="Average Temperature"
                                           [data]="serviceListSummary"
                                           [width]="'100%'"
                                           [height]="350"
                                           [gridX]="true"
                                           [horizontal]="true"
                                           [gridY]="true"
                                           [xAxis]="xAxis"
                                           [showXlabel]="true"
                                           [showYlabel]="true"
                                           columnWidth="25%"
                                           chart_type="line"
                                           LegendPosition="top"
                                           horizontalAlign="right"
                            ></app-bar-graph>
                        </div>
                    } @else {
                        <div
                                class="col-span-3 md:col-span-2 w-full"
                                *ngIf="humLineChartsData as serviceListSummary">
                            <app-bar-graph
                                           title="Average Humidity"
                                           [data]="serviceListSummary"
                                           [width]="'100%'"
                                           [height]="350"
                                           [gridX]="true"
                                           [horizontal]="true"
                                           [gridY]="true"
                                           [xAxis]="xAxis"
                                           [showXlabel]="true"
                                           [showYlabel]="true"
                                           columnWidth="25%"
                                           chart_type="line"
                                           LegendPosition="top"
                                           horizontalAlign="right"
                            ></app-bar-graph>
                        </div>
                    }
                }

            </div>
        </div>

        <div class="flex">
            <div class="flex gap-2">
                @for (tab of heatmapTabs; track tab) {
                    @if (activeSlug === tab?.slug) {
                        <div class="bg-primary-50 text-primary-600 shadow py-2 px-3 rounded-xl">
                            {{ tab?.name }}
                        </div>
                    } @else {
                        <div (click)="activeSlug = tab?.slug" class="hover:bg-primary-50/60 hover:text-primary p-2 rounded-xl cursor-pointer">
                            {{ tab?.name }}
                        </div>
                    }
                }
            </div>
        </div>

        @if (activeSlug === 'temperature') {
            <app-heatmap-graph *ngIf="showChart"
                               [colors]="['#F59E0B']"
                               [data]="temperatureHeatmapData"
                               [xAxis]="heatmapXAxis"></app-heatmap-graph>
        } @else {

            <app-heatmap-graph *ngIf="showChart"
                               [colors]="['#3B82F6']"
                               [data]="humidityHeatmapData"
                               [xAxis]="heatmapXAxis"></app-heatmap-graph>
        }

        <div class="mt-8 grid grid-cols-12 gap-10">
            <div class="col-span-12 md:col-span-8">
                <app-warehouse-zone-list></app-warehouse-zone-list>
            </div>
            <div class="col-span-12 md:col-span-4">
                <div class="border-2 shadow-lg border-gray-50 p-1 flex flex-col gap-2 rounded-xl">
                    <div class="bg-gray-50 p-4 rounded-xl">
                        <span class="font-bold text-gray-700">Building Details</span>
                    </div>

                    <div class="px-3 pb-3 flex flex-col gap-2 rounded-xl" *ngFor="let items of data">
                        <view-details-item
                                key="Building Name"
                                [value]="items.name">
                        </view-details-item>
                        <view-details-item
                                key="Total Capacity"
                                [value]="items.totalCapacity">
                        </view-details-item>
                        <view-details-item
                                key="Number of Zones"
                                [value]="items.numberOfZones">
                        </view-details-item>
                    </div>
                </div>
            </div>
        </div>
    </div>


</app-shared-layout>
